module.exports = __webpack_public_path__ + "static/media/lego.12dc477c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/lego.png
// module id = 82
// module chunks = 0